import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";
import { ProFormList } from '../../List';
export var formList = function formList(item, _ref) {
  var genItems = _ref.genItems;

  if (item.valueType === 'formList' && item.dataIndex) {
    var _item$getFieldProps, _ref2, _ref2$rules, _ref2$rules$, _item$getFormItemProp, _item$getFieldProps2, _ref3, _ref3$rules, _ref3$rules$, _item$getFormItemProp2, _item$getFieldProps3;

    if (!item.columns || !Array.isArray(item.columns)) return null;
    return _jsx(ProFormList, _objectSpread(_objectSpread({
      name: item.dataIndex,
      label: item.label,
      initialValue: item.initialValue,
      colProps: item.colProps,
      rowProps: item.rowProps
    }, (_item$getFieldProps = item.getFieldProps) === null || _item$getFieldProps === void 0 ? void 0 : _item$getFieldProps.call(item)), {}, {
      isValidateList: (_ref2 = ((_item$getFormItemProp = item.getFormItemProps) === null || _item$getFormItemProp === void 0 ? void 0 : _item$getFormItemProp.call(item)) || ((_item$getFieldProps2 = item.getFieldProps) === null || _item$getFieldProps2 === void 0 ? void 0 : _item$getFieldProps2.call(item))) === null || _ref2 === void 0 ? void 0 : (_ref2$rules = _ref2.rules) === null || _ref2$rules === void 0 ? void 0 : (_ref2$rules$ = _ref2$rules[0]) === null || _ref2$rules$ === void 0 ? void 0 : _ref2$rules$.required,
      emptyListMessage: (_ref3 = ((_item$getFormItemProp2 = item.getFormItemProps) === null || _item$getFormItemProp2 === void 0 ? void 0 : _item$getFormItemProp2.call(item)) || ((_item$getFieldProps3 = item.getFieldProps) === null || _item$getFieldProps3 === void 0 ? void 0 : _item$getFieldProps3.call(item))) === null || _ref3 === void 0 ? void 0 : (_ref3$rules = _ref3.rules) === null || _ref3$rules === void 0 ? void 0 : (_ref3$rules$ = _ref3$rules[0]) === null || _ref3$rules$ === void 0 ? void 0 : _ref3$rules$.message,
      children: genItems(item.columns)
    }), item.key);
  }

  return true;
};